import { setupAppConfig } from '@app/infrastructure/auth/setup-app-config';
import './sentry';
import { CustomerType } from '@partners/customer-type.enum';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';

setupAppConfig()
	.then((config) => platformBrowserDynamic(config).bootstrapModule(AppModule))
	.catch((err) => console.error(err));

//	map of relative request url to the promise of its response.
//  used to cache responses for the purpose of sharing them with the guest (remote) app
window.zestyHost = {
	sharedResponsePromisesByUrl: {},
	authToken: '',
	currentOrganization: null,
	featureFlags: {},
	isSupportedUser: false,
	permissions: [],
	user: null,
	userRole: null,
	tempConfig: {},
	customerType: '' as CustomerType,
};
